import { CalendarEvent } from '@src/types/Events';
import { normalizeStackId } from '../utils';

export const generateValues = (activeEvent: CalendarEvent): CalendarEvent => ({
  title: activeEvent?.title || '',
  start: activeEvent?.start || '',
  end: activeEvent?.end || '',
  rrule: activeEvent?.rrule
    ? {
        ...activeEvent.rrule,
        byweekday: activeEvent.rrule.byweekday ?? [],
        interval: activeEvent.rrule.interval ?? 1,
        until: activeEvent.rrule.until ?? null,
      }
    : null,
  duration: activeEvent?.duration || '00:30:00',
  backgroundColor: activeEvent?.backgroundColor || '#5FC8F1',
  stackId: normalizeStackId(activeEvent?.stackId),
  startCommands: activeEvent?.startCommands || [],
  stopCommands: activeEvent?.stopCommands || [],
});
